
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pistemap",
      function () {
        return require("private-next-pages/[region]/[resort]/pistemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pistemap"])
      });
    }
  